import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert'
import { Platform } from 'react-native'
import { setGlobal, useGlobal } from '../../../global/useGlobal'

export enum TYPES_SEVERITY {
  error = 'error',
  warning = 'warning',
  success = 'success',
}
interface SnackbarWebProps {
  message?: string
  onClose?: () => void
  open?: boolean
  severity?: TYPES_SEVERITY
  duration?: number
}

const DEFAULT_ERROR_SNACKBAR_DURATION = 5000

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

export const SnackbarWeb: React.FC<SnackbarWebProps> = (props) => {
  if (Platform.OS !== 'web') {
    return false as any
  }
  const [snackbar] = useGlobal('snackBar')
  const autoHideDuration = DEFAULT_ERROR_SNACKBAR_DURATION
  const onClose = () => {
    setGlobal({ snackBar: undefined })
  }

  return (
    <Snackbar open={snackbar?.isOpen} autoHideDuration={autoHideDuration} onClose={onClose}>
      { snackbar &&
        <Alert onClose={onClose} severity={snackbar?.isError ? TYPES_SEVERITY.error : TYPES_SEVERITY.success}>
          {snackbar?.message}
        </Alert>
      }
    </Snackbar>
  )
}
